function f(r, s) {
  const o = {};
  return r && s.forEach((i) => {
    i === "onClick" ? o[i] = (t) => {
      t.preventDefault(), t.stopPropagation();
    } : o[i] = void 0;
  }), o;
}
export {
  f as disableEventHandlers
};
